@if (isLoading()) {
  <div class="flex justify-center items-center h-32">
    <mat-spinner diameter="40" />
  </div>
} @else {
  <div class="flex flex-col gap-4">
    @if (spots().length === 0) {
      <p class="text-center text-gray-500 py-8">{{ 'waters.fishing-spots.no-spots' | translate }}</p>
    } @else {
      <mat-table [dataSource]="spots()">
        <!-- Number column -->
        <ng-container matColumnDef="number">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.fishing-spots.column.number' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.number ?? '—' }}</mat-cell>
        </ng-container>

        <!-- Fishermen count column -->
        <ng-container matColumnDef="spots">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.fishing-spots.column.fishermenCount' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.spots ?? '—' }}</mat-cell>
        </ng-container>

        <!-- Active column -->
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.fishing-spots.column.active' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><app-bool [value]="row.isActive" /></mat-cell>
        </ng-container>

        <!-- Dummy column -->
        <ng-container matColumnDef="isDummy">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.fishing-spots.column.dummy' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><app-bool [value]="row.isDummy" /></mat-cell>
        </ng-container>

        <!-- Actions column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.fishing-spots.column.actions' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              [matTooltip]="'waters.form.edit-title' | translate"
              (click)="editSpot(row.id); $event.stopPropagation()">
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              [matTooltip]="'waters.form.delete' | translate"
              [disabled]="deletingId() === row.id"
              (click)="deleteSpot(row.id); $event.stopPropagation()">
              @if (deletingId() === row.id) {
                <mat-spinner diameter="18" />
              } @else {
                <mat-icon>delete</mat-icon>
              }
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" />
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="editSpot(row.id)" class="cursor-pointer hover:bg-gray-50" />
      </mat-table>
    }
  </div>
}
